// TODO: Platform/global configuration value to be shared between runtime and build scripts.
// Used for 1/2 size textures for faster initial loading. This value is imported into runtime scripts in `src/Utility/Resource/intermediateAssets.ts`.
module.exports = {
    INTERMEDIATE_ASSETS_SCALE : 0.5
}
